import { UHttp } from "../../utils/UHttp";
import { Service } from "../professional/service-model";
import { OptionCategory } from '../professional/option-category-model';

export interface ApiResponse<T> {
    success: boolean;
    message: string;
    status:number;
    data: T;
}


const apiUrlServer = process.env.REACT_APP_URL_SERVER;

export class ClientServiceModel {
    private static instance: ClientServiceModel;

    private constructor() {}

    public static getInstance(): ClientServiceModel {
        if (!ClientServiceModel.instance) {
            ClientServiceModel.instance = new ClientServiceModel();
        }
        return ClientServiceModel.instance;
    }

    /**
     * Récupère les services d'une entreprise par son nom commercial
     * @returns Réponse API contenant la liste des services
     * @param businessName
     */
    async getServicesByProfessional(businessName: string): Promise<ApiResponse<Service[]>> {
        try {
            const response = await UHttp.get(
                `${apiUrlServer}/public-api/service/collaborator/${businessName}`,
                UHttp.publicApiHeaders()
            );
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const responseData = await response.json();
            return {
                ...responseData,
                status: response.status
            }
        } catch (error: any) {
            throw error;
        }
    }

    /**
     * Récupère les catégories d'options pour un service
     * @param serviceId ID du service
     * @returns Liste des catégories d'options
     */
    async getOptionCategoriesByService(serviceId: string): Promise<OptionCategory[]> {
        try {
            const response = await UHttp.get(
                `${apiUrlServer}/public-api/option-category/service/${serviceId}`,
                UHttp.publicApiHeaders()
            );
            const responseData = await response.json();
            return {
                ...responseData,
                status: response.status
            }
        } catch (error) {
            throw error;
        }
    }

}